import Client from "shopify-buy/index.unoptimized.umd";

const shopifyClient = (store_info) => Client.buildClient({
    domain: store_info.url,
    storefrontAccessToken: store_info.auth_key,
    apiVersion: "2019-07"
});

export default shopifyClient;